<template>
  <div>
    <div class="version5-head">
      <LayoutHeadBanner
        v-if="_.get(this.$store.state.current_content, 'secondary.LayoutHeadBanner.conf.enabled')==1"
        :itemData="_.get(this.$store.state.current_content,'secondary.LayoutHeadBanner.data')"
      />
    </div>
    <Breadcrumb />

    <Overview
      v-if="_.get($store.state.current_content, 'secondary.programContent.conf.enabled') == 1"
      :itemData="_.get($store.state.current_content, 'secondary.programContent.data')[0]"
    />

    <ServiceSlider
      v-if="_.get(this.$store.state.current_content, 'secondary.ServiceSlider.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.ServiceSlider')"
      :colorData="newsCol"
    />

    <NewsBlock
      class="no-top-p"
      v-if="_.get(this.$store.state.current_content, 'secondary.NewsBlock.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.NewsBlock')"
      :colorData="newsCol"
    />
  </div>
</template>

<script>
import LayoutHeadBanner from "@/components/LayoutHeadBanner";
import Breadcrumb from "@/components/Breadcrumb";
import ServiceSlider from "@/components/ServiceSlider";
import NewsBlock from "@/components/NewsBlock";
import Overview from "@/components/Overview";

export default {
  components: {
    LayoutHeadBanner,
    Breadcrumb,
    ServiceSlider,
    NewsBlock,
    Overview
  },
  data(){
    return{
      newsCol: "whiteCol"
    }
  }
};
</script>
<style>
  .no-top-p .pt-89{
    padding-top: 0;
  }
</style>